module.exports = __webpack_public_path__ + "img/brushes-tablet_jp.c1b7428.jpg";